import { styled } from 'goober';

import type { ConnectionStatus } from './mcp-oauth-connection-status';

export const SectionDivider = styled('hr')`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colors.gray.c4};
  margin: 0;
  width: 100%;
`;

const getStatusDotColor = (
  status: ConnectionStatus,
  theme: {
    colors: {
      blue: { primaryA: string };
      gray: { c8: string };
    };
  },
): string => {
  switch (status) {
    case 'waiting':
      return theme.colors.blue.primaryA;
    case 'notConnected':
    default:
      return theme.colors.gray.c8;
  }
};

export const StatusDot = styled('span')<{ $status: ConnectionStatus }>`
  background-color: ${({ $status, theme }) =>
    getStatusDotColor($status, theme)};
  border-radius: 50%;
  flex-shrink: 0;
  height: 8px;
  width: 8px;

  ${({ $status }) =>
    $status === 'waiting'
      ? `
    animation: mcp-oauth-waiting-pulse 2s ease-in-out infinite;

    @keyframes mcp-oauth-waiting-pulse {
      0%,
      100% {
        opacity: 1;
      }

      50% {
        opacity: 0.35;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  `
      : ''}
`;
